import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeroSection from "../../Components/Home/HeroSection/HeroSection";
import StatsSection from "../Home/Stats/Stats";
import ProductsSection from "../Home/Products/Products";
import SeamlessSection from "../Home/SeamlessSection/SeamlessSection";
// import FMCG_Section from "../Home/FMCG_Section/FMCG_Section";
import IntelligentStore from "../Home/Intelligent_Store/Intelligent_Store";
import WhyFulupo from "../Home/WhyFulupo/WhyFulupo";
import ActionSection from "../Home/Action_Section/Action_Section"
import ContactSection from "../Home/Contact_Section/Contact_Section"
import GenerationSection from "../Home/Generation_Section/Generation_Section"
import Roadmap from "../Home/Roadmap_Section/Roadmap_Section";
import VisionAndRevolution from "../Home/Vision_and_Revolution/Vision_and_Revolution";
import InvestorsForm from "../Forms/Investorsform/investorsform";
import EnquiryModal from "../Forms/Header/Enquiry_form";
import ComingSoonModal from "../Common/ComingSoonModal/ComingSoonModal";


const HomePage = () => {
  const [isInvestorFormOpen, setInvestorFormOpen] = useState(false);
  const [isEnquiryModalOpen, setEnquiryModalOpen] = useState(false);
  const [isComingSoonOpen, setComingSoonOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const sectionId = location.pathname.slice(1);
    const validSections = ["home", "products", "features", "demo", "future"];
    
    if (validSections.includes(sectionId)) {
      requestAnimationFrame(() => {
        const element = document.getElementById(sectionId);
        element?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    } else if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.pathname]);

  const closeForm = () => setInvestorFormOpen(false);

  return (
    <>
      <section id="home">
        <HeroSection
          onOpenStoreKeeper={() => setEnquiryModalOpen(true)}
          onOpenConsumers={() => setComingSoonOpen(true)}
        />
      </section>
      <section id="stats"><StatsSection /></section>
      <section id="products"><ProductsSection /></section>
      <section id="features"><SeamlessSection /></section>
      {/* <section id="features"><FMCG_Section /></section> */}
      <section id="features"><IntelligentStore /></section>
      <section id="features"><WhyFulupo /></section>
      <section id="demo"><ActionSection /></section>
      <section id="demo"><ContactSection /></section>
      <section id="future"><GenerationSection /></section>
      <section id="future"><Roadmap /></section>
      <section id="future"><VisionAndRevolution onOpenComingSoon={() => setComingSoonOpen(true)} onOpenInvestors={() => setInvestorFormOpen(true)} /></section>

      <InvestorsForm
        isOpen={isInvestorFormOpen}
        onClose={closeForm}
      />

      <EnquiryModal
        isOpen={isEnquiryModalOpen}
        onClose={() => setEnquiryModalOpen(false)}
      />

      <ComingSoonModal
        isOpen={isComingSoonOpen}
        onClose={() => setComingSoonOpen(false)}
      />
    </>
  );
};

export default HomePage;
